import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Heart, Zap, Leaf, Wind, Droplet, Sparkles } from 'lucide-react';

const iconMap = {
  Sleep: Moon,
  Desire: Heart,
  Focus: Zap,
  Calm: Leaf,
  Gut: Wind,
  Breath: Droplet,
  Skin: Sparkles
};

export default function RitualCategoryCard({ category, description, onClick }) {
  const Icon = iconMap[category] || Sparkles;

  return (
    <motion.div
      whileHover={{ y: -4, boxShadow: '6px 6px 20px rgba(59, 42, 35, 0.15), -6px -6px 20px rgba(255, 255, 255, 0.8)' }}
      onClick={onClick}
      className="card-neumorphic p-8 cursor-pointer group"
      data-testid={`ritual-category-${category.toLowerCase()}`}
    >
      <div className="flex flex-col items-start space-y-4">
        <div className="p-3 bg-tiger-orange/10 rounded-lg transition-colors group-hover:bg-tiger-orange/20">
          <Icon className="w-8 h-8 text-tiger-orange" />
        </div>
        <div>
          <h3 className="font-playfair text-2xl font-semibold text-dark-cedar mb-2">
            {category} Ritual
          </h3>
          <p className="text-dark-cedar/70 text-sm leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </motion.div>
  );
}